/* 🤖 this file was generated by svg-to-ts */
export const matIconSwipeLeftAlt: {
  name: 'swipe-left-alt';
  data: string;
} = {
  name: 'swipe-left-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.1 13a5 5 0 1 0 0-2H5.83l1.59-1.59L6 8l-4 4 4 4 1.41-1.41L5.83 13h4.27zm4.9 2c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/></svg>`
};
